import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';
import { useUrlGenerator } from '../contexts/RoutesContext';

// OAuth required params
// client_id
// redirect_uri
// response_type
// scope
// state
// code_challenge
// code_challenge_method

const useLoginComplete = () => {
    const { search } = useLocation();
    const route = useUrlGenerator();
    const onLoginComplete = useCallback(() => {
        const { next = null, ...props } = parseQuery(search);

        const nextUrl = `${next}${
            Object.keys(props).length > 0 ? `?${stringifyQuery(props)}` : ''
        }`;

        window.location.href = next !== null ? nextUrl : route('account');
    }, [route, search]);

    return onLoginComplete;
};

export default useLoginComplete;
